var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',_vm._b({attrs:{"fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},'g',_vm.$attrs,false),[_c('path',{attrs:{"d":"M12 7.5a.375.375 0 1 1 0-.75.375.375 0 0 1 0 .75m0 3V18"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"11"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }